<template>
  <div class="modal">
    <div class="modal-container">
      <div>
        <h3 class="modal-title">{{ textTitle }}</h3>
        <div class="modal-text">{{ textBody }} <br><br> {{ textQuest }}</div>
      </div>
      <div class="modal-footer">
        <button @click="remove" class="button button__del">
          <img src="/static/icons/icon-del.png" alt="alt">{{ $t('common.delete') }}
        </button>
        <button @click="cancel" class="button button__can">{{ $t('common.cancel') }}</button>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'modal-remove-vacancy',

    props: {
      selectedVacanciesLength: {
        type: Number,
        default: 0
      }
    },

    computed: {
      textBody() {
        if(this.selectedVacanciesLength > 1) {
          return this.$tr('vacancies.response.deletes');
        } else {
          return this.$tr('vacancies.response.delete');
        }
      },

      textQuest() {
        if(this.selectedVacanciesLength > 1) {
          return this.$tr('vacancies.response.deleteQuestions');
        } else {
          return this.$tr('vacancies.response.deleteQuestion');
        }
      },

      textTitle() {
        if(this.selectedVacanciesLength > 1) {
          return this.$tr('vacancies.response.checkVacancies');
        } else {
          return this.$tr('vacancies.response.checkVacancy');
        }
      }
    },

    methods: {
      remove () {
        this.$emit('remove')
      },
      cancel () {
        this.$emit('cancel')
      }
    }
  }
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.modal {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  transition: opacity 0.3s ease;

  &-container {
    width: 513px;
    margin: 50px auto 20px;
    padding: 38px 9px 32px;
    background-color: #fff;
    border: 1px solid #d2d6e0;
    border-radius: 2px;
    transition: all 0.3s ease;
    box-shadow: none;
    text-align: center;
  }

  &-title {
    font-weight: 500;
    line-height: 26px;
    font-size: 18px;
    letter-spacing: 0.005em;
    margin: 0;
  }

  &-text {
    margin: 25px auto 32px;
    max-width: 400px;
  }

  .button {
    user-select: none;
    background: #f4f5f7;
    text-align: center;
    font-size: 15px;
    font-weight: 500;
    line-height: 22px;
    height: 40px;
    box-sizing: border-box;
    padding: 9px 20px;
    cursor: pointer;
    border-radius: 2px;
    border: none;
    outline: none;
    position: relative;
    display: inline-block;
    white-space: nowrap;
    margin: 0 10px;

    &__del {
      color: #f65046;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        display: inline-block;
        margin-right: 11px;
      }
    }

    &__can {
      color: $green;
    }
  }
}
</style>
